const PAGAMENTO_HOSTS_PERMITIDOS: readonly string[] = ['asaas.com'];

const hostPermitido = (hostname: string): boolean =>
  PAGAMENTO_HOSTS_PERMITIDOS.some(
    (permitido) => hostname === permitido || hostname.endsWith(`.${permitido}`),
  );

/**
 * Guard de checkout dos funis self: só abre URL https em host do gateway de
 * pagamento (Asaas). A URL vem da API, mas uma resposta adulterada ou errada
 * não pode virar redirect para fora do gateway.
 */
export function urlPagamentoSegura(url: string | null | undefined): url is string {
  if (!url) return false;
  try {
    const { protocol, hostname } = new URL(url);
    return protocol === 'https:' && hostPermitido(hostname);
  } catch {
    return false;
  }
}
